export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img src="assets/imgs/Dinghy.png" alt="Dinghy" />
          <p>
            A full-time DevOps &amp; AI engineering team helping companies ship
            reliable, scalable, intelligent platforms.
          </p>
        </div>

        <div className="footer__col">
          <h4>Services</h4>
          <a href="#services">DevOps Engineering</a>
          <a href="#services">CI/CD Pipelines</a>
          <a href="#services">Cloud &amp; Kubernetes</a>
          <a href="#services">AI &amp; Agent Systems</a>
          <a href="#services">FinOps</a>
        </div>

        <div className="footer__col">
          <h4>Company</h4>
          <a href="#about">About</a>
          <a href="#team">Team</a>
          <a href="#blog">Blog</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer__col">
          <h4>Contact</h4>
          <a href="mailto:yehuda@dinghy.co.il">yehuda@dinghy.co.il</a>
          <span>Israel - remote worldwide</span>
        </div>
      </div>

      <div className="footer__bottom">
        <span>&copy; {year} Dinghy. All rights reserved.</span>
        <span>
          Illustrations by{" "}
          <a href="https://storyset.com/work" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </span>
      </div>
    </footer>
  );
}
